module.exports = __webpack_public_path__ + "static/media/4.b12248f5.jpg";